export const REPLY_RECOMMENDATIONS_MESSAGE = 'REPLY_RECOMMENDATIONS_MESSAGE';